import { Directive } from '@angular/core';

@Directive({
  selector: '[listGroupTemplate]',
  standalone: true,
})
export class ListGroupTemplateDirective {}
